import { getThemeName } from '../../utils/dist/commons.esm.js';
import 'react';
import barlowMetrics from '@capsizecss/metrics/barlow';
import cabinFontmetrics from '@capsizecss/metrics/cabin';
import openSansFontmetrics from '@capsizecss/metrics/openSans';
import 'styled-components';

var typography$3 = {
  subtitle1: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  subtitle2: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  overline: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 400
  }
};

var typography$2 = {
  display: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  display1: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  display2: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  title1: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  title2: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  title3: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  title4: {
    fontFamily: "'Cabin', sans-serif",
    fontWeight: 700
  },
  lead1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400
  },
  lead2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400
  },
  subtitle1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600
  },
  subtitle2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600
  },
  body1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400
  },
  body2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400
  },
  button1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 700
  },
  button2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 700
  },
  detail1: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600
  },
  detail2: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400
  },
  overline: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600
  }
};

var typography$1 = {
  display: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  display1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  display2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  title1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  title2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  title3: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  title4: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  lead1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 400
  },
  lead2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 400
  },
  subtitle1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  subtitle2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  body1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 400
  },
  body2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 400
  },
  button1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  button2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  detail1: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 700
  },
  detail2: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 400
  },
  overline: {
    fontFamily: "'F37 Bolton', sans-serif",
    fontWeight: 600
  }
};

var typography = {
  display: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  display1: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  display2: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  title1: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  title2: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  title3: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  title4: {
    fontFamily: "\"tt-commons-pro\", sans-serif",
    fontWeight: 600
  },
  lead1: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 400
  },
  lead2: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 400
  },
  subtitle1: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 600
  },
  subtitle2: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 600
  },
  body1: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 400
  },
  body2: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 400
  },
  button1: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 700
  },
  button2: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 700
  },
  detail1: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 600
  },
  detail2: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 400
  },
  overline: {
    fontFamily: "\"Barlow\", sans-serif",
    fontWeight: 600
  }
};

var metrics$1 = {
  capHeight: 717,
  ascent: 714,
  descent: -286,
  lineGap: 250,
  unitsPerEm: 1000
};

var metrics = {
  capHeight: 700,
  ascent: 1000,
  descent: -200,
  lineGap: 0,
  unitsPerEm: 1000
};

var fonts = {
  barlow: {
    fontFamily: "'Barlow'",
    capsizeSettings: barlowMetrics
  },
  cabin: {
    fontFamily: "'Cabin'",
    capsizeSettings: cabinFontmetrics
  },
  f37Bolton: {
    fontFamily: "'F37 Bolton'",
    capsizeSettings: metrics$1
  },
  openSans: {
    fontFamily: "'Open Sans'",
    capsizeSettings: openSansFontmetrics
  },
  ttCommons: {
    fontFamily: "'tt-commons-pro'",
    capsizeSettings: metrics
  }
};
var getFontMetrics = fontDeclaration => {
  var fontName = fontDeclaration.split(',')[0];
  // find the enum key if the fontName is one of our fonts
  var fontKey = Object.keys(fonts).find(key => fonts[key].fontFamily === fontName);
  if (fontKey) return fonts[fontKey].capsizeSettings;
  return openSansFontmetrics;
};

var textVariants = [
/*
 * @deprecated use 'display1' instead
 */
'display', 'display1', 'display2', 'title1', 'title2', 'title3', 'title4', 'lead1', 'lead2', 'subtitle1', 'subtitle2', 'body1', 'body2', 'button1', 'button2', 'detail1', 'detail2', 'overline'];
function getTypography(variant, property) {
  var themeName = getThemeName();
  var baseTypography = typography$2;
  var themeTypography = {
    // This is a bit confusing, but because Lendi Next is the foundation for all themes, on order to
    // create the "legacy" set of typography, we need to merge them together here to form
    // the default.
    lendi: Object.assign({}, baseTypography, typography$3),
    'lendi-next': baseTypography,
    domain: Object.assign({}, baseTypography, typography$1),
    aussie: Object.assign({}, baseTypography, typography)
  };
  if (property === 'fontMetrics') {
    return getFontMetrics(themeTypography[themeName][variant].fontFamily);
  }
  return themeTypography[themeName][variant][property];
}

export { getTypography as default, textVariants };
